import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';

import { AccessoryDtoSchema } from '../schemas/AccessoryDto';

export const PathParametersSchema = z.object({
	Id: z.string(),
});
export type PathParameters = z.infer<typeof PathParametersSchema>;

export const QueryParametersSchema = z.object({
	CurrencyCode: z.string().optional(),
});
export type QueryParameters = z.infer<typeof QueryParametersSchema>;

// No RequestBody

const ResponseDataSchema = z.lazy(() => AccessoryDtoSchema);
export type ResponseData = z.infer<typeof ResponseDataSchema>;
const validator = createValidator(ResponseDataSchema);

export async function callApi(input: {
	queryParameters: QueryParameters;
	pathParameters: PathParameters;
}): Promise<Optional<ResponseData>> {
	const url: string = SERVICEBASEURL.BACKEND + `/Accessory/${input.pathParameters.Id}`;
	return (
		await axios
			.get(url, {
				params: input.queryParameters,
			})
			.toOptionalFiltered(validator)
	).map((x) => x.data);
}
